// Modelo Dinamico para monitoreo.

//TIPO 0: Solo LABEL
//{valor:"", descripcion:"", tipo:0 ,label:"g. Exposiciones en trabajos anteriores (ver HCU):",label2:"Tipo Detalle"},

//TIPO 1: select con opciones
//{valor:"", descripcion:"", tipo:1 ,label:"a. Datos de filiación:" ,data:["SI","NO"]},

//TIPO 2: Select con opciones y un campo con descripcion
//{valor:"", descripcion:"", valor2:"", tipo:2 ,label:"Discoteca:",data:["SI","NO"],label2:"veces/mes"},

//TIPO 3: Campo para observaciones inputText
//{valor:"", descripcion:"", tipo:3 ,label:"Valor:"},

//TIPO 4: Campo para observaciones textArea
//{valor:"", descripcion:"", tipo:4 ,label:"Valor:"},

export default class MonitoreoRespiratorioRolandMorris {
    fecha={}
    lista=[
        {
            encabezado:"Datos de filiación",
            datos:[
                {valor:"", descripcion:"", tipo:21 ,label:"      C.I.: 1721930442", bold:false},
                {valor:"", descripcion:"", tipo:22 ,label:"      Edad: 32", bold:false},
                {valor:"", descripcion:"", tipo:23 ,label:"      Apellidos y nombres: LOPEZ CRISTIAN", bold:false},
                {valor:"", descripcion:"", tipo:24 ,label:"      Empresa: PRIVADOS", bold:false},
                {valor:"", descripcion:"", tipo:25 ,label:"      Puesto de trabajo: PRIVADO", bold:false},
            ]
        },
        {
            encabezado:"CUESTIONARIO NÓRDICO",
            datos:[

                {valor:"", descripcion:"", tipo:0 ,label:"En los últimos tres meses, ¿ha tenido molestias en...?" ,bold:true },

                {valor:"", descripcion:"", tipo:1 ,label:"Cuello" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Hombro derecho" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Hombro izquierdo" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Espalda" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Codo-antebrazo derecho" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Codo-antebrazo izquierdo" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Mano-muñeca derecho" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Mano-muñeca izquierda" ,data:["SI","NO"]},

                {valor:"", descripcion:"", tipo:0 ,label:"¿Cuánto tiempo lleva con molestias?" ,bold:true },

                {valor:"", descripcion:"", tipo:14 ,label:"Cuello" ,data:["1 mes o menos","de 2 a 3 meses","de 4 a 6 meses","de 7 a 9 meses","10 a 12 meses"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Hombro derecho" ,data:["1 mes o menos","de 2 a 3 meses","de 4 a 6 meses","de 7 a 9 meses","10 a 12 meses"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Hombro izquierdo" ,data:["1 mes o menos","de 2 a 3 meses","de 4 a 6 meses","de 7 a 9 meses","10 a 12 meses"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Espalda" ,data:["1 mes o menos","de 2 a 3 meses","de 4 a 6 meses","de 7 a 9 meses","10 a 12 meses"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Codo-antebrazo derecho" ,data:["1 mes o menos","de 2 a 3 meses","de 4 a 6 meses","de 7 a 9 meses","10 a 12 meses"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Codo-antebrazo izquierdo" ,data:["1 mes o menos","de 2 a 3 meses","de 4 a 6 meses","de 7 a 9 meses","10 a 12 meses"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Mano-muñeca derecho" ,data:["1 mes o menos","de 2 a 3 meses","de 4 a 6 meses","de 7 a 9 meses","10 a 12 meses"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Mano-muñeca izquierda" ,data:["1 mes o menos","de 2 a 3 meses","de 4 a 6 meses","de 7 a 9 meses","10 a 12 meses"]},

                {valor:"", descripcion:"", tipo:0 ,label:"¿Ha decidido cambiar de puesto de trabajo por sus molestias en ...?" ,bold:true },

                {valor:"", descripcion:"", tipo:14 ,label:"Cuello" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Hombro derecho" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Hombro izquierdo" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Espalda" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Codo-antebrazo derecho" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Codo-antebrazo izquierdo" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Mano-muñeca derecho" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Mano-muñeca izquierda" ,data:["SI","NO"]},

                {valor:"", descripcion:"", tipo:0 ,label:"Duración de estas molestias los últimos 3 meses" ,bold:true },

                {valor:"", descripcion:"", tipo:14 ,label:"Cuello" ,data:["1 a 7 días","8 a 30 días",">30 días discont","Permanentemente"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Hombro derecho" ,data:["1 a 7 días","8 a 30 días",">30 días discont","Permanentemente"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Hombro izquierdo" ,data:["1 a 7 días","8 a 30 días",">30 días discont","Permanentemente"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Espalda" ,data:["1 a 7 días","8 a 30 días",">30 días discont","Permanentemente"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Codo-antebrazo derecho" ,data:["1 a 7 días","8 a 30 días",">30 días discont","Permanentemente"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Codo-antebrazo izquierdo" ,data:["1 a 7 días","8 a 30 días",">30 días discont","Permanentemente"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Mano-muñeca derecho" ,data:["1 a 7 días","8 a 30 días",">30 días discont","Permanentemente"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Mano-muñeca izquierda" ,data:["1 a 7 días","8 a 30 días",">30 días discont","Permanentemente"]},

                {valor:"", descripcion:"", tipo:0 ,label:"Duración del episodio de dolor" ,bold:true },

                {valor:"", descripcion:"", tipo:14 ,label:"Cuello" ,data:["<1 hora","1 a 24 horas","1 a 7 días","1 a 4 semanas",">1 mes"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Hombro derecho" ,data:["<1 hora","1 a 24 horas","1 a 7 días","1 a 4 semanas",">1 mes"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Hombro izquierdo" ,data:["<1 hora","1 a 24 horas","1 a 7 días","1 a 4 semanas",">1 mes"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Espalda" ,data:["<1 hora","1 a 24 horas","1 a 7 días","1 a 4 semanas",">1 mes"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Codo-antebrazo derecho" ,data:["<1 hora","1 a 24 horas","1 a 7 días","1 a 4 semanas",">1 mes"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Codo-antebrazo izquierdo" ,data:["<1 hora","1 a 24 horas","1 a 7 días","1 a 4 semanas",">1 mes"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Mano-muñeca derecho" ,data:["<1 hora","1 a 24 horas","1 a 7 días","1 a 4 semanas",">1 mes"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Mano-muñeca izquierda" ,data:["<1 hora","1 a 24 horas","1 a 7 días","1 a 4 semanas",">1 mes"]},

                {valor:"", descripcion:"", tipo:0 ,label:"Días incapacidad últimos 3 meses" ,bold:true },

                {valor:"", descripcion:"", tipo:14 ,label:"Cuello" ,data:["0 día","1 a 7 días","1 a 4 semanas",">1 mes"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Hombro derecho" ,data:["0 día","1 a 7 días","1 a 4 semanas",">1 mes"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Hombro izquierdo" ,data:["0 día","1 a 7 días","1 a 4 semanas",">1 mes"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Espalda" ,data:["0 día","1 a 7 días","1 a 4 semanas",">1 mes"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Codo-antebrazo derecho" ,data:["0 día","1 a 7 días","1 a 4 semanas",">1 mes"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Codo-antebrazo izquierdo" ,data:["0 día","1 a 7 días","1 a 4 semanas",">1 mes"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Mano-muñeca derecho" ,data:["0 día","1 a 7 días","1 a 4 semanas",">1 mes"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Mano-muñeca izquierda" ,data:["0 día","1 a 7 días","1 a 4 semanas",">1 mes"]},

                {valor:"", descripcion:"", tipo:0 ,label:"¿Ha recibido tratamiento médico en los últimos tres meses?" ,bold:true },

                {valor:"", descripcion:"", tipo:14 ,label:"Cuello" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Hombro derecho" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Hombro izquierdo" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Espalda" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Codo-antebrazo derecho" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Codo-antebrazo izquierdo" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Mano-muñeca derecho" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Mano-muñeca izquierda" ,data:["SI","NO"]},

                {valor:"", descripcion:"", tipo:0 ,label:"Molestias últimos 7 días" ,bold:true },

                {valor:"", descripcion:"", tipo:14 ,label:"Cuello" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Hombro derecho" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Hombro izquierdo" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Espalda" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Codo-antebrazo derecho" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Codo-antebrazo izquierdo" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Mano-muñeca derecho" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Mano-muñeca izquierda" ,data:["SI","NO"]},

                {valor:"", descripcion:"", tipo:0 ,label:"Intensidad molestias (1 leve; 4 muy fuerte)" ,bold:true },

                {valor:"", descripcion:"", tipo:14 ,label:"Cuello" ,data:["1","2","3","4"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Hombro derecho" ,data:["1","2","3","4"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Hombro izquierdo" ,data:["1","2","3","4"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Espalda" ,data:["1","2","3","4"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Codo-antebrazo derecho" ,data:["1","2","3","4"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Codo-antebrazo izquierdo" ,data:["1","2","3","4"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Mano-muñeca derecho" ,data:["1","2","3","4"]},
                {valor:"", descripcion:"", tipo:14 ,label:"Mano-muñeca izquierda" ,data:["1","2","3","4"]},

                {valor:"", descripcion:"", tipo:0 ,label:"A qué atribuye estas molestias" ,bold:true },

                {valor:"", descripcion:"", tipo:3 ,label:"Cuello" },
                {valor:"", descripcion:"", tipo:3 ,label:"Hombro derecho" },
                {valor:"", descripcion:"", tipo:3 ,label:"Hombro izquierdo" },
                {valor:"", descripcion:"", tipo:3 ,label:"Espalda" },
                {valor:"", descripcion:"", tipo:3 ,label:"Codo-antebrazo derecho" },
                {valor:"", descripcion:"", tipo:3 ,label:"Codo-antebrazo izquierdo" },
                {valor:"", descripcion:"", tipo:3 ,label:"Mano-muñeca derecho" },
                {valor:"", descripcion:"", tipo:3 ,label:"Mano-muñeca izquierda" },
            ]
        },
    ]
}
var today = new Date();
var dd = today.getDate();
var mm = today.getMonth() + 1; //January is 0!

var yyyy = today.getFullYear();
if (dd < 10) {
    dd = '0' + dd;
}
if (mm < 10) {
    mm = '0' + mm;
}
var today = dd + '/' + mm + '/' + yyyy;





// WEBPACK FOOTER //
// ./src/model/MonitoreoMusculoEsqueleticoNordico.js